import {
  REQUEST_TENANT_BRAND_NAMES,
  REQUEST_TENANT_DISTRIBUTORS,
  REQUEST_TENANT_LANGUAGES,
  REQUEST_TENANT_PRODUCT_PRIORITIES,
  REQUEST_TENANT_RELOAD,
  REQUEST_TENANT_TYPES,
  REQUEST_TENANTS,
  TenantActionTypes
} from "./types";
import { isOk } from "../../result";
import { Tenant, TenantType } from "../../models/Tenant";
import * as TenantApi from "../../api/tenantApi";
import { Distributor, Priority } from "../../models/Product";
import { Language } from "../../models/Translation";

const fetchTenantTypes = (
  payload: ReadonlyArray<TenantType>
): TenantActionTypes => ({
  type: REQUEST_TENANT_TYPES,
  payload
});

const fetchTenantBrandNames = (
  payload: ReadonlyArray<string>
): TenantActionTypes => ({
  type: REQUEST_TENANT_BRAND_NAMES,
  payload
});

export const reloadTenant = (): TenantActionTypes => ({
  type: REQUEST_TENANT_RELOAD,
  payload: true
});

function fetchTenants(tenants: ReadonlyArray<Tenant>): TenantActionTypes {
  return {
    type: REQUEST_TENANTS,
    payload: tenants
  };
}

function fetchTenantsDistributors(
  distributors: ReadonlyArray<Distributor>
): TenantActionTypes {
  return {
    type: REQUEST_TENANT_DISTRIBUTORS,
    payload: distributors
  };
}

function fetchTenantsProductPriorities(
  priorities: ReadonlyArray<Priority>
): TenantActionTypes {
  return {
    type: REQUEST_TENANT_PRODUCT_PRIORITIES,
    payload: priorities
  };
}

function fetchCurrentTenantLanguages(
  languages: ReadonlyArray<Language>
): TenantActionTypes {
  return {
    type: REQUEST_TENANT_LANGUAGES,
    payload: languages
  };
}

export const thunkFetchTenants = () => async (dispatch: any) => {
  const result = await TenantApi.list();

  if (!isOk(result)) {
    console.error(result.details);
    return;
  }

  dispatch(fetchTenants(result.value));
};

export const thunkFetchTenantDistributors = () => async (dispatch: any) => {
  const result = await TenantApi.listTenantDistributors();

  if (!isOk(result)) {
    console.error(result.details);
    return;
  }

  dispatch(fetchTenantsDistributors(result.value));
};

export const thunkFetchTenantTypes = () => async (dispatch: any) => {
  const result = await TenantApi.listTenantTypes();

  if (!isOk(result)) {
    console.error(result.details);
    return;
  }

  dispatch(fetchTenantTypes(result.value));
};

export const thunkFetchBrandNames = () => async (dispatch: any) => {
  const result = await TenantApi.listTenantBrandNames();

  if (!isOk(result)) {
    console.error(result.details);
    return;
  }

  dispatch(fetchTenantBrandNames(result.value));
};

export const thunkFetchProductPriorities = () => async (dispatch: any) => {
  const result = await TenantApi.listTenantProductPriorities();

  if (!isOk(result)) {
    console.error(result.details);
    return;
  }

  dispatch(fetchTenantsProductPriorities(result.value));
};

export const thunkFetchCurrentTenantLanguages = () => async (dispatch: any) => {
  const result = await TenantApi.getCurrentTenantLanguages();

  if (!isOk(result)) {
    console.error(result.details);
    return;
  }

  dispatch(fetchCurrentTenantLanguages(result.value));
};
